import {
  SYSTEM_COMPANYTYPE_MODAL_CHANGE,
} from './constants';

export function companyTypeModalChange(visible,type) {
  return {
    type: SYSTEM_COMPANYTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_COMPANYTYPE_MODAL_CHANGE:
      return {
        ...state,
        companyTypeModalType:action.data.type,
        companyTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/companyTypeModalChange.js